export default function MetalhomeKlosek() {
  return (
    <div className="min-h-screen py-16 md:py-24 px-4 md:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 text-center mb-6">
          Metalhome Klosek
        </h1>
        <p className="text-foreground-600 text-center mb-12 max-w-2xl mx-auto">
          Ihr Spezialist für hochwertige Metallarbeiten im Wohnbereich.
        </p>

        <div className="space-y-8 text-foreground-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Wohnliche Metallgestaltung
            </h2>
            <p>
              Metalhome Klosek steht für hochwertige Metallarbeiten im Wohnbereich. Von individuellen Treppengeländern über maßgeschneiderte Küchenarbeitsplatten bis hin zu edlen Möbelgestellen — wir verwirklichen Ihre Wohnideen aus Metall.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Unsere Leistungen für Ihr Zuhause
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                'Treppengeländer & Handläufe',
                'Balkongeländer & Brüstungen',
                'Küchenarbeitsplatten & Gestelle',
                'Möbelgestelle & Tischuntergestelle',
                'Regale & Aufbewahrungssysteme',
                'Dekorative Metallelemente',
              ].map((item, index) => (
                <div key={index} className="flex items-center gap-3 p-4 bg-background-100 rounded-lg">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-50 flex-shrink-0">
                    <i className="ri-check-line text-primary-500 text-sm"></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-800">{item}</span>
                </div>
              ))}
            </div>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Individuelle Beratung
            </h2>
            <p>
              Jedes Projekt ist einzigartig. Wir beraten Sie persönlich, entwickeln gemeinsam mit Ihnen die optimale Lösung und setzen diese mit höchster Präzision um. Durch CAD-Zeichnungen erhalten Sie bereits vor der Fertigung eine genaue Vorstellung Ihres Produkts.
            </p>
          </section>

          <div className="mt-10 flex justify-center">
            <a
              href="tel:023515691455"
              className="inline-flex items-center gap-3 px-8 py-4 bg-primary-500 text-background-50 font-semibold rounded-md hover:bg-primary-600 transition-colors shadow-md"
            >
              <i className="ri-phone-line text-xl"></i>
              <span>Jetzt anrufen</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}